import ApiService from './ApiService'

const ComplianceReportService = {
    fetchComplianceReports(client) {
        return ApiService.get('kyc.compliance_reports', { client })
    },

    show(reportId) {
        return ApiService.get('kyc.compliance_reports.show', { compliance_report: reportId })
    },

    update(reportId, data) {
        return ApiService.patch('kyc.compliance_reports.update', data, { compliance_report: reportId })
    },

    destroy(reportId) {
        return ApiService.delete('kyc.compliance_reports.destroy', { compliance_report: reportId })
    },

    create(contract, data) {
        return ApiService.post('kyc.compliance_reports.store', data, { contract })
    },

    requestApproval(reportId) {
        return ApiService.post('kyc.compliance_reports.request_approval', {}, { compliance_report: reportId })
    },

    approve(reportId, outcome = 'approved', validityMonths = null) {
        return ApiService.post(
            'kyc.compliance_reports.approve',
            { outcome, validity_months: validityMonths },
            { compliance_report: reportId }
        )
    },

    // No filename: the backend generates the PDF and names it via Content-Disposition.
    downloadPdf(reportId) {
        return ApiService.downloadFile('kyc.compliance_reports.pdf', null, {
            compliance_report: reportId,
        })
    },
}

export default ComplianceReportService
